import { connect } from 'react-redux';

import { sessionSet } from '../actions';
import { RootState } from '../store';

interface StateProps {
  session: string;
}

interface DispatchProps {
  setSession: (data: string) => void;
}

const mapStateToProps = (state: RootState): StateProps => ({
  session: state.session ?? ''
});

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  setSession: (data: string) => dispatch(sessionSet(data))
});

export default connect(mapStateToProps, mapDispatchToProps);
